/**
 * Utility functions for triggering InWin notifications
 */

/**
 * Show "Changes saved!" notification
 * @param {boolean} topOnly - If true, only show top banner, no modal popup
 */
export const showChangesSavedNotification = (topOnly = false) => {
	const notification = {
		type: 'success',
		message: 'Changes saved!',
		timestamp: Date.now(),
		topOnly: topOnly
	}
	localStorage.setItem('inwinNotification', JSON.stringify(notification))
}

/**
 * Show "Changes unsaved" notification
 * @param {string} customMessage - Custom error message
 * @param {boolean} topOnly - If true, only show top banner, no modal popup
 */
export const showChangesUnsavedNotification = (customMessage = 'Changes unsaved', topOnly = false) => {
	const notification = {
		type: 'error',
		message: customMessage,
		timestamp: Date.now(),
		topOnly: topOnly
	}
	localStorage.setItem('inwinNotification', JSON.stringify(notification))
}

/**
 * Check if device is mobile (same pattern used throughout the app)
 */
const isMobileDevice = () => window.innerWidth <= 767

/**
 * Show notification based on device type
 * @param {string} notificationType - 'success' or 'error'
 * @param {string} customMessage - Custom message for success/error notifications
 * @param {boolean} topOnly - If true, only show top banner, no modal popup (mobile only)
 */
export const showNotificationBasedOnDevice = (notificationType, customMessage, topOnly = false) => {
	if (isMobileDevice()) {
		// Mobile: Use new notification system
		if (notificationType === 'success') {
			// Use custom success message if provided, otherwise default
			const successMessage = customMessage || 'Changes saved!'
			const notification = {
				type: 'success',
				message: successMessage,
				timestamp: Date.now(),
				topOnly: topOnly
			}
			localStorage.setItem('inwinNotification', JSON.stringify(notification))
		} else if (notificationType === 'error') {
			showChangesUnsavedNotification(customMessage, topOnly)
		}
	} else {
		// Desktop: Use original toaster system
		const { toaster } = require('./toast-wrapper')
		if (notificationType === 'success') {
			toaster.info(customMessage || 'Changes has been applied')
		} else if (notificationType === 'error') {
			toaster.error(customMessage || 'Changes could not be saved')
		}
	}
}

/**
 * Redirect to profile page with notification (mobile only - for mobile navigation)
 * @param {object} history - React router history object
 * @param {string} notificationType - 'success' or 'error'
 * @param {string} customMessage - Custom message for error notifications
 * @param {boolean} topOnly - If true, only show top banner, no modal popup
 */
export const redirectToProfileWithNotification = (history, notificationType, customMessage, topOnly = false) => {
	if (notificationType === 'success') {
		showChangesSavedNotification(topOnly)
	} else if (notificationType === 'error') {
		showChangesUnsavedNotification(customMessage, topOnly)
	}

	// Get the base path from the environment (respects BASEHREF)
	const basePath = typeof BASEHREF !== 'undefined' && BASEHREF ? BASEHREF : ''
	const profilePath = `${basePath}/profile`

	// Small delay to ensure localStorage is set before navigation
	setTimeout(() => {
		if (history && typeof history.push === 'function') {
			history.push('/profile')
		} else {
			// Fallback to window.location if history is not available
			// Use the full path with base href for deployment compatibility
			window.location.href = profilePath
		}
	}, 100)
} 